import type { StateCreator } from 'zustand';

export interface UserSlice {
  credits: number;
  setCredits: (credits: number) => void;
  isCreditsLoading: boolean;
  setIsCreditsLoading: (loading: boolean) => void;
  areCreditsAvailable: boolean | null;
  setAreCreditsAvailable: (available: boolean | null) => void;
  pendingUpload: { id: string; file: File } | null;
  setPendingUpload: (upload: { id: string; file: File } | null) => void;
}

export const userInitialState = {
  credits: 0,
  isCreditsLoading: false,
  areCreditsAvailable: null as boolean | null,
  pendingUpload: null as { id: string; file: File } | null,
};

export const createUserSlice: StateCreator<UserSlice, [], [], UserSlice> = (
  set
) => ({
  ...userInitialState,

  setCredits: (credits) => set({ credits }),
  setIsCreditsLoading: (isCreditsLoading) => set({ isCreditsLoading }),
  setAreCreditsAvailable: (areCreditsAvailable) => set({ areCreditsAvailable }),
  setPendingUpload: (pendingUpload) => set({ pendingUpload }),
});
